module.exports = __webpack_public_path__ + "static/img/audio.e27d5bf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio.gif
// module id = n37S
// module chunks = 49